const Invoice = {
    item: {},
    imagePath: "",
    message: "",
    userTypes: []
}

const RuleText = {
    item: ""
}

const initialState = {
    Invoice,
    RuleText
}

export default initialState;
